export const isString = (str) => typeof str === 'string' || str instanceof String